import React, { useState } from "react";
import { Row } from "react-bootstrap";
import { Outlet, useLocation } from "react-router-dom";
import "./LandingPage.css";
import chevron_right from "../../../assets/chevron_right.svg";
import { connect } from "react-redux";
import { useEffect } from "react";
const StoreProfile = React.lazy(() =>
  import("../../dashboard/components/StoreProfile")
);
const SidenavPage = React.lazy(() =>
  import("../../sidenav/components/SidenavPage")
);

function Landing(props) {
  const location = useLocation();
  const [showSidenav, setShowsidenav] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const showSidenavbar = () => {
    setShowsidenav(true);
  };
  const [showProfile, setShowprofile] = useState(false);
  useEffect(() => {
    if (props.logindata.vendor_type !== "driver") {
      setShowprofile(true);
    } else {
      setShowprofile(false);
    }
    // eslint-disable-next-line
  }, [location?.state?.obj]);
  return (
    <aside className="Landing-outlet">
      <aside className="dashboard">
        <div
          className={"vendor"}
          style={{
            paddingTop: props.logindata.vendor_type === "driver" ? "7rem" : "",
          }}
        >
          {showProfile ? (
            <StoreProfile 
              storedetail={props?.storedetail}
              innerClass={"col-xl-12 py-4 px-4"}
              className={"storeprofilediv comman"}
              type={"StoreProfile"}
            />
          ) : (
            <></>
          )}
          {/* Mobile side bar icon */}
          <div
            className="sidemenu_icon"
            style={{ display: showSidenav ? "none" : "" }}
            onClick={() => showSidenavbar()}
          >
            <img src={chevron_right} alt="right"></img>
          </div>
          <div className="col-xl-12  boxes vendor_dashboard_main_div">
            <Row className="mobileview_row">
              <div
                className={`col-xl-3 col-lg-3 slide-tab mb-3 ${
                  showSidenav ? "slide_tab_visible" : ""
                }`}
              >
                <aside
                  className={`landing-sidenav ${showSidenav ? "show" : ""}`}
                >
                  <SidenavPage
                    showSidenav={showSidenav}
                    setShowsidenav={setShowsidenav}
                    setShowModal={setShowModal}
                    showModal={showModal}
                  />
                </aside>
              </div>
              <div
                className={`landig_page ${
                  showSidenav ? "showing_landingpage" : ""
                } mb-3`}
              >
                <Outlet />
              </div>
            </Row>
          </div>
        </div>
      </aside>
    </aside>
  );
}

const mapStateToProps = (state) => ({
  storedetail: state?.dashboard?.storeDetail,
  logindata: state?.login?.logindata,
});

export default connect(mapStateToProps)(Landing);
